import React from 'react';
import { Download } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubTrigger,
  DropdownMenuSubContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Scope options only apply to the "opportunities" endpoint. For other endpoints
// the classic CSV/XLSX menu is preserved.
const OPPORTUNITY_SCOPES = [
  { key: 'all', label: 'Todas las oportunidades' },
  { key: 'active', label: 'Solo activas (sin cerrar)' },
  { key: 'won', label: 'Solo Ganadas' },
  { key: 'closed', label: 'Solo cerradas (Ganada / Perdida / Descartada)' },
  { key: 'archived', label: 'Solo archivadas' },
];

const ExportMenu = ({ endpoint, filters = {}, label = 'Exportar' }) => {
  const isOpportunities = endpoint === 'opportunities';

  const handleExport = (format, extraParams = {}) => {
    const params = new URLSearchParams({ format, ...filters, ...extraParams });
    const url = `${API}/export/${endpoint}?${params.toString()}`;
    window.open(url, '_blank');
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" data-testid="export-button">
          <Download className="w-4 h-4 mr-2" />
          {label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-72">
        {isOpportunities ? (
          <>
            <DropdownMenuLabel>Formato XLSX (con estilos)</DropdownMenuLabel>
            {OPPORTUNITY_SCOPES.map((s) => (
              <DropdownMenuItem
                key={`xlsx-${s.key}`}
                onClick={() => handleExport('xlsx', { scope: s.key })}
                data-testid={`export-xlsx-${s.key}`}
              >
                {s.label}
              </DropdownMenuItem>
            ))}
            <DropdownMenuSeparator />
            <DropdownMenuLabel>Formato CSV (importar a otra herramienta)</DropdownMenuLabel>
            <DropdownMenuSub>
              <DropdownMenuSubTrigger data-testid="export-csv-submenu">
                Elegir alcance…
              </DropdownMenuSubTrigger>
              <DropdownMenuSubContent>
                {OPPORTUNITY_SCOPES.map((s) => (
                  <DropdownMenuItem
                    key={`csv-${s.key}`}
                    onClick={() => handleExport('csv', { scope: s.key })}
                    data-testid={`export-csv-${s.key}`}
                  >
                    {s.label}
                  </DropdownMenuItem>
                ))}
              </DropdownMenuSubContent>
            </DropdownMenuSub>
          </>
        ) : (
          <>
            <DropdownMenuItem onClick={() => handleExport('csv')} data-testid="export-csv">
              Exportar CSV
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => handleExport('xlsx')} data-testid="export-xlsx">
              Exportar XLSX
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ExportMenu;
